interface Percentage {
	men_exposed: number;
	women_exposed: number;
	other_exposed: number;
}

// interface GeneralInformationsResultAttributes {}

export class GeneralInformationsResult {
	public readonly men_exposed: number;
	public readonly women_exposed: number;
	public readonly other_exposed: number;
	public readonly activity_description: string;
	public readonly percentages: Percentage;

	constructor({ men_exposed, women_exposed, other_exposed, activity_description, percentages }: any) {
		this.men_exposed = men_exposed;
		this.women_exposed = women_exposed;
		this.other_exposed = other_exposed;
		this.activity_description = activity_description;
		this.percentages = {
			men_exposed: percentages.men_exposed,
			women_exposed: percentages.women_exposed,
			other_exposed: percentages.other_exposed
		};
	}
}
